import React from 'react';
import { Circle, Check } from '@phosphor-icons/react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type Props = Omit<React.ComponentPropsWithRef<typeof Badge>, 'variant'> & {
  variant?: React.ComponentPropsWithRef<typeof Badge>['variant'] | 'accepted';
  suffix?: React.ReactNode;
};

export const StatusBadge = React.forwardRef<HTMLSpanElement, Props>(
  ({ className, suffix, variant, children, ...props }, ref) => {
    const Icon = variant === 'accepted' ? Check : Circle;
    const badgeVariant = variant === 'accepted' ? 'success' : variant;
    const weight = variant === 'accepted' ? 'bold' : 'fill';
    const size = variant === 'accepted' ? `!size-3` : `!size-2`;

    return (
      <span ref={ref} className={cn('flex items-center gap-1 rounded-md p-1', suffix && 'bg-dark-300', className)}>
        <Badge {...props} variant={badgeVariant}>
          <span className="flex items-center gap-1">
            <Icon weight={weight} size={8} className={size} />
            {children}
          </span>
        </Badge>
        {suffix && <span className="text-xs text-default">{suffix}</span>}
      </span>
    );
  },
);

StatusBadge.displayName = 'StatusBadge';
